import { StyleSheet } from 'aphrodite';
import { waitGray } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		backgroundColor: '#ffffff',
	},
	title: {
		fontSize: 18,
		fontWeight: 600,
		margin: 0,
		marginBottom: 8,
		color: '#1f2937',
	},
	description: {
		fontSize: 13,
		color: '#6b7280',
		margin: 0,
		marginBottom: 16,
	},
	filterContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 6,
		marginBottom: 16,
	},
	filterButton: {
		padding: '4px 10px',
		fontSize: 12,
		fontWeight: 500,
		backgroundColor: '#f3f4f6',
		color: '#6b7280',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
		transition: 'all 0.15s ease',
		':hover': {
			backgroundColor: '#e5e7eb',
			color: '#374151',
		},
	},
	filterButtonActive: {
		backgroundColor: '#6366f1',
		color: '#ffffff',
		':hover': {
			backgroundColor: '#4f46e5',
			color: '#ffffff',
		},
	},
	nodeList: {
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
	},
	paletteNode: {
		padding: 12,
		borderRadius: 8,
		border: '2px solid',
		cursor: 'grab',
		transition: 'all 0.2s ease',
		':hover': {
			transform: 'translateY(-2px)',
			boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
		},
		':active': {
			cursor: 'grabbing',
		},
		':focus': {
			outline: '2px solid #6366f1',
			outlineOffset: 2,
		},
	},
	// Communication - colors match canvas node borders from stepTypeColors.ts
	node_email: {
		borderColor: '#F4C6E3',
		backgroundColor: '#FDF2F9',
		color: '#C75DA6', // emailActivityTintColor
	},
	node_texting: {
		borderColor: '#B8D5FE',
		backgroundColor: '#EFF6FF',
		color: '#3E8BFE', // brandSecondary
	},
	node_newsletter: {
		borderColor: '#C9E8A9',
		backgroundColor: '#F4FAED',
		color: '#89C947', // newsletterActivityTintColor
	},
	node_card: {
		borderColor: '#D4B8E8',
		backgroundColor: '#F5EEFA',
		color: '#6E27A3', // campaignTintColor
	},
	// Tasks - actionItemTintColor green
	node_task: {
		borderColor: '#C9E8A9',
		backgroundColor: '#F4FAED',
		color: '#89C947', // actionItemTintColor
	},
	node_opportunity: {
		borderColor: '#C9E8A9',
		backgroundColor: '#F4FAED',
		color: '#89C947', // actionItemTintColor
	},
	// Tags
	node_tag: {
		borderColor: '#B3D4FF',
		backgroundColor: '#EBF4FF',
		color: '#0466FF', // brandPrimary
	},
	node_tagRemove: {
		borderColor: '#FDDCBE',
		backgroundColor: '#FFF7ED',
		color: '#F89143', // orange
	},
	// Control flow
	node_wait: {
		borderColor: '#E0E0E0',
		backgroundColor: '#F9F9F9',
		color: waitGray,
	},
	node_doNothing: {
		borderColor: '#E0E0E0',
		backgroundColor: '#F9F9F9',
		color: waitGray,
	},
	node_conditional: {
		borderColor: '#B3D4FF',
		backgroundColor: '#EBF4FF',
		color: '#0466FF', // brandPrimary (switch step)
	},
	node_triggerAutomation: {
		borderColor: '#B3D4FF',
		backgroundColor: '#EBF4FF',
		color: '#0466FF', // brandPrimary
	},
	nodeHeader: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginBottom: 4,
	},
	nodeLabel: {
		fontSize: 14,
		fontWeight: 600,
		color: '#1f2937',
	},
	nodeDescription: {
		fontSize: 12,
		color: '#6b7280',
		marginLeft: 24,
	},
});
